export enum ExternalURLs {
  LinkedInPage = 'https://www.linkedin.com/company/the-xp-lab/',
  DiscordInvite = 'https://discord.gg/aWTWHDqQW4',
  DiscordInviteIntoBugReportChannel = 'https://discord.com/channels/1455148484746416140/1458496864298209444',
}